import { render, staticRenderFns } from "./bonusSection.vue?vue&type=template&id=2baeea4e&scoped=true&"
import script from "./bonusSection.vue?vue&type=script&lang=js&"
export * from "./bonusSection.vue?vue&type=script&lang=js&"
import style0 from "./bonusSection.vue?vue&type=style&index=0&id=2baeea4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2baeea4e",
  null
  
)

export default component.exports